import React from "react";
import { LoloAdmin, LoloResource } from 'react-admin-lolo';
import { Route } from 'react-router-dom';
import * as ra from 'react-admin';

import { Dashboard  } from './dashboard';
import RadTest from './RadTest';
import ShowDevice from './ShowDevice';

import Layout from './layout';

const App = () => (
  <LoloAdmin
    apiUrl={process.env.REACT_APP_API_URL}
    dashboard={Dashboard}
    title='Lolo PVPC'
    layout={Layout}
    customRoutes={[
      <Route exact path="/radtest" component={RadTest} />
    ]}
    >
    <LoloResource
      name='enterprises'
    />
    <LoloResource
      name='csps'
    />
    <LoloResource
      name='apns'
    />
    <LoloResource
      name='apn-groups'
    />
    <LoloResource
      name='apn-grants'
    />
    <LoloResource
      name='device-groups' 
    />
    <LoloResource
      name='devices'
      show={ShowDevice}
      createWithId={true}
    />
    <LoloResource
      name='device-ids'
    />
    <LoloResource
      name='dns-records'
    />
    <LoloResource
      name='acls'
    />
    <LoloResource
      name='aggregations'
    />
    <LoloResource
      name='automations'
    />
    <LoloResource
      name='subnets'
      edit={null}
      create={null}
    />
    <LoloResource
      name='sessions'
      edit={null}
      create={null}
    />
  </LoloAdmin>
);

export default App;